










































































































































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrBiduiPreviewZygczb extends Vue {
  @Prop()
  private message: any;
}
